import { ReactElement } from "react";
import {
  Biotech as BiotextIcon,
  Description as DocumentIcon,
  Apartment as ApartmentIcon,
} from "@mui/icons-material";

export const drawerWidth = 240;

interface MenuItem {
  text: string;
  icon: ReactElement;
  path: string;
}

export const menuItems: MenuItem[] = [
  { text: "Documents", icon: <DocumentIcon />, path: "/documents" },
  { text: "Properties", icon: <ApartmentIcon />, path: "/properties" },
  ...(process.env.NODE_ENV === "development"
    ? [{ text: "Sandbox", icon: <BiotextIcon />, path: "/sandbox" }]
    : []),
];
